import {
    get,
    isEqual
} from 'lodash';
import { saveToSessionStorage, loadFromSessionStorage } from '../../utils/sessionStorage';
import {
    generateMerchantIdsString,
    TOGGLE_SELECTOR_OPEN,
    UPDATE_SELECTED_MERCHANTS
} from './merchantSelectorActions';
import { MERCHANTS_SUCCESS } from '../Merchants/merchantsActions';
import { createSelector } from 'reselect';
import _ from 'lodash';
import { getViewStateByName } from '../appViewStates';
import { MAX_MERCHANTS } from './Popup/MerchantSelectorList/MerchantSelectorList';

const sessionStorageSelectedMerchantsKey = 'emvio-selected-merchants';
const sessionStorageAllMerchantsSelectedKey = 'emvio-all-merchants-selected';

export default function reducer(state = {
    selectedMerchants: []
}, action = {}) {
    let newState;

    switch (action.type) {
        case MERCHANTS_SUCCESS: {
            const storedSelectedMerchants = loadFromSessionStorage(sessionStorageSelectedMerchantsKey);
            const isAllSelected = loadFromSessionStorage(sessionStorageAllMerchantsSelectedKey);
            let selectedMerchants = action.merchants.slice(0);

            if (!isAllSelected && storedSelectedMerchants) {
                selectedMerchants = action.merchants.filter((merchant) => {
                    return storedSelectedMerchants.includes(merchant.merchantId);
                });
            }

            if (_.size(selectedMerchants) > MAX_MERCHANTS) {
                selectedMerchants = _.slice(selectedMerchants, 0, MAX_MERCHANTS);
            }

            newState = {
                ...state,
                selectedMerchants
            };

            return isEqual(state, newState) ? state : newState;
        }

        case TOGGLE_SELECTOR_OPEN:
            newState = {
                ...state,
                isOpen: !state.isOpen
            };

            return isEqual(state, newState) ? state : newState;

        case UPDATE_SELECTED_MERCHANTS:
            saveToSessionStorage(sessionStorageSelectedMerchantsKey, action.merchants.map((merchant) => merchant.merchantId));
            saveToSessionStorage(sessionStorageAllMerchantsSelectedKey, action.isAllSelected);

            newState = {
                ...state,
                selectedMerchants: action.merchants
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getMerchantSelectorViewState = createSelector(
    (state) => state,
    (state) => getViewStateByName(state, 'merchantSelector')
);

export const getSelectedMerchants = createSelector(
    getMerchantSelectorViewState,
    (viewState) => get(viewState, 'selectedMerchants')
);

export const getSelectedMerchantIdsString = createSelector(
    getSelectedMerchants,
    (merchantsArray = []) => {
        return generateMerchantIdsString(merchantsArray);
    }
);

export const getIsSelectorOpen = createSelector(
    getMerchantSelectorViewState,
    (viewState) => get(viewState, 'isOpen')
);

export const getDoAnySelectedMerchantsHaveFraud = createSelector(
    getSelectedMerchants,
    (merchants = []) => merchants.some((merchant) => merchant.kountMerc)
);
